<template>
  <div class="booking-wrapper">
    <div class="room-list">
      <step4-booking-room
          :booking-room="bookingRoom"
          :start="start"
          :end="end"
          :lock="lock"
          :room-price="booking.room_price"
          :options="booking.price_options"
          :use-actions="!loading"
          :use-update="hasPrice"
          v-for="bookingRoom in bookingRooms"
          :key="bookingRoom.id"></step4-booking-room>
    </div>
    <div class="price-details" v-if="hasPrice">
      <div class="price-line" v-if="hasHostingPrice">
        <div>{{ $t('step4-multi.booking-room.total.room') }}</div>
        <div class="price">{{ hostingPrice | decimalPrice }}€</div>
      </div>
      <div class="price-line" v-if="hasExtraPrice">
        <div>{{ $t('step4-multi.booking-room.total.extra') }}</div>
        <div class="price">{{ extraPrice | decimalPrice }}€</div>
      </div>
      <div class="price-line" v-if="hasOptions">
        <div>{{ $t('step4-multi.booking-room.total.option') }}</div>
        <div class="price">{{ optionPrice | decimalPrice }}€</div>
      </div>
      <div class="price-line" v-if="hasTouristTax">
        <div>{{ $t('step4-multi.booking-room.total.tax') }}</div>
        <div class="price">{{ touristTax | decimalPrice }}€</div>
      </div>
      <div class="price-line" v-if="hasDiscount">
        <div>{{ $t('step4-multi.booking-room.total.discount') }}</div>
        <div class="price">{{ discount }}€</div>
      </div>
      <div class="price-line price-total" v-if="hasTotal">
        <div>{{ $t('step4-multi.booking-room.total.total') }}</div>
        <div class="price">{{ totalPrice | decimalPrice }}€</div>
      </div>
    </div>
    <template v-if="!hasPrice">
      <div class="danger-info">
        <span>
          Cette réservation a été réalisée avec un tarif qui ne correspond plus à notre grille tarifaire. Veuillez renouveller la réservation.
        </span>
        <div class="actions">
          <button @click="deleteBooking">Supprimer</button>
        </div>
      </div>
    </template>
    <template v-if="hasPrice">
      <template v-if="isCurrentPaying && errors.length > 0">
        <div class="error-container">
          <div class="error-message" v-for="(error, index) in errors" :key="index">
            {{ $t(error.message) }}
          </div>
        </div>
      </template>
      <template v-if="!isCurrentPaying && !loading">
        <div class="booking-validation">
          <div class="form-send">
            <button class="do-payin" @click="handleSetPayin">
              {{ $t('step4-multi.booking-room.pay', index, total) }}
            </button>
          </div>
        </div>
      </template>
      <template v-if="isCurrentPaying && loading">
        <loader style="height: 80px"/>
      </template>
      <template v-if="isCurrentPaying && !loading">
        <div class="personal-data">
          <step4-personal-informations :booking-id="booking.id"></step4-personal-informations>
        </div>

        <div class="payment">
          <step4-paiment-informations :booking-id="booking.id"></step4-paiment-informations>
        </div>

        <div class="booking-validation">
          <div class="total-price">
            {{ $t('paiment-informations.amount') }} <strong>{{ this.totalPrice | decimalPrice }} €</strong>
            {{ $t('paiment-informations.debit') }}.
          </div>
          <form @submit="send" class="form-send">
            <div id="fields" class="field cgvcgu">
              <checkbox-input @input="handleCheckBox" class="checkboxFont" name="conditions" :html-needed="true"
                              :label="`${$t('paiment-informations.iAccept')}<a class='orange' href='javascript:openModal(1)'> ${$t('paiment-informations.conditions')}.</a>`"/>
            </div>
            <div class="field">
              <save-card-input v-model="accepted"/>
            </div>
            <input class="submit payment-button" type="submit" :value="$t('step4.payment.accept')" @click="send"
                   :disabled="disabled || !accepted">
          </form>
        </div>
      </template>
    </template>
  </div>

</template>

<script>
import Step4BookingRoom from "./step4-booking-room";
import extraPrice from '../../../components/mixins/extra-price.mixin';
import moment from 'moment';
import Step4PersonalInformations from "./step4-personal-informations";
import Step4PaimentInformations from "./step4-paiment-informations";

import CheckboxInput from '../../../components/checkbox-input';
import SaveCardInput from "../../../components/save-card-input";
import {mapState} from "vuex";
import Loader from "../../../components/loader.component";

export default {
  name: "step4-booking",
  components: {
    Loader,
    Step4PaimentInformations, Step4PersonalInformations, Step4BookingRoom, CheckboxInput, SaveCardInput
  },
  mixins: [extraPrice],
  props: {
    booking: {
      required: true,
    },
    index: {
      type: Number,
    },
    total: {
      type: Number
    }
  },
  data() {
    return {
      accepted: false,
      lock: false,
    }
  },
  methods: {
    async deleteBooking() {
      await this.$store.dispatch('shoppingCart/booking/delete', this.booking.id);
    },
    handleCheckBox(value) {
      this.$store.commit('bookingStep4/SET_TERM_ACCEPTED', value);
    },
    async send(e) {
      if (this.lock) return;
      e.preventDefault()
      e.stopPropagation();
      this.lock = true;
      this.$emit('lock', true);
      const response = await this.$store.dispatch('shoppingCart/createBooking');
      if (!response) {
        this.lock = false;
        this.$emit('lock', false);
      } else if (response.redirect === null) {
        await this.$router.push({name: 'step5', query: response.params})
      } else if (response.redirect) {
        window.onbeforeunload = null;
        window.location.assign(response.redirect);
      }
    },
    async handleSetPayin() {
      if (this.lock) return;
      await this.$store.dispatch('shoppingCart/setPaying', this.booking.id);
    }
  },
  computed: {
    ...mapState({
      loading: s => s.shoppingCart.payLoading,
      errors: s => s.shoppingCart.payErrors.map(error => {
        if (typeof error === 'string') return {message: `errors.${error}`};
        if (error.error) error = error.error;
        if (error.type) return {message: `errors.${error.type}`}
        return {message: error.message, _from: error};
      })
    }),
    disabled() {
      return false;
    },
    hasPrice() {
      for (const bookingRoom of this.booking.booking_rooms) {
        for (const plan of bookingRoom.price_plans) {
          for (const input of plan.input_prices) {
            if (input.edges.length === 0) return false;
          }
        }
      }
      return this.totalPrice > 0;
    },
    isCurrentPaying() {
      return this.$store.state.shoppingCart.paying && this.$store.state.shoppingCart.paying.id === this.booking.id;
    },
    bookingRooms() {
      return this.booking.booking_rooms;
    },
    start() {
      return moment(this.booking.start);
    },
    end() {
      return moment(this.booking.end);
    },
    hasHostingPrice() {
      return true;
    },
    hostingPrice() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.price_plans.reduce((total, pp) => {
          return total + pp.input_prices.reduce((ppTotal, input) => {
            return ppTotal + input.edges.reduce((ppEdges, edge) => {
              return ppEdges + edge.hostingPrice;
            }, 0);
          }, 0)
        }, 0);
      }, 0)
    },
    hasTouristTax() {
      return true;
    },
    hasOptions() {
      return this.optionPrice > 0;
    },
    optionPrice() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.price_plans.reduce((total, pp) => {
          return total + pp.input_prices.reduce((ppTotal, input) => {
            return ppTotal + input.edges.reduce((ppEdges, edge) => {
              return ppEdges + edge.optionsBasePrice + edge.optionsAdditionalPrice;
            }, 0);
          }, 0)
        }, 0);
      }, 0)
    },
    touristTax() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.price_plans.reduce((total, pp) => {
          return total + pp.input_prices.reduce((ppTotal, input) => {
            return ppTotal + input.edges.reduce((ppEdges, edge) => {
              return ppEdges + edge.touristTax;
            }, 0);
          }, 0)
        }, 0);
      }, 0)
    },
    hasTotal() {
      return true;
    },
    totalPrice() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.price_plans.reduce((total, pp) => {
          return total + pp.input_prices.reduce((ppTotal, input) => {
            return ppTotal + input.edges.reduce((ppEdges, edge) => {
              return ppEdges + edge.totalPrice;
            }, 0);
          }, 0)
        }, 0);
      }, 0) + this.extraPrice;
    },
    hasExtraPrice() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.extras.length;
      }, 0) > 0;
    },
    extraPrice() {
      return this.booking.booking_rooms.reduce((tt, br) => {
        return tt + br.extras.reduce((total, extra) => {
          return total + this.calcExtraPrice(extra.extra, extra.dates, false)
        }, 0);
      }, 0)
    },
    hasDiscount() {
      return false;
    },
    discount() {
      return 0;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi/step4-booking.vue